import { Injectable,SecurityContext } from '@angular/core';
import { Subject } from 'rxjs';
import { DomSanitizer } from '@angular/platform-browser';
import { GuestService } from '../../services/guest.service';


@Injectable({
  providedIn: 'root'
})

export class DynamicFormService {
  selectedCountryCode: string;
  selectedRadioOption: number;
  requiredPhoneNumberLength$: number;
  HTMLPattern = "^[^<>]+$"
  selectedCountryId: number;
  countriesList = [];
  ValidateGuestPhoneNumber: boolean = true;
  constructor(private domSanitizer: DomSanitizer,private guestService: GuestService) { }

  onInputChange(event, backspace) {
    let newVal = event ? event.replace(/\D/g, '') : '';
    //let newVal =  backspace? event:event.replace(/\D/g, '');
    let stringCount;
    if (newVal) {
      if(backspace){
        newVal = newVal.substring(0, newVal.length);
      }
      else{
        const country = this.countriesList.find(c => c.Id == (this.guestService.selectedCountryId || this.selectedCountryId));
        stringCount = country?.PhoneNumberLength;
        // Security: PhoneNumberPattern comes from GetCountries (untrusted server data) and used to be
        // executed via new Function/eval on each keystroke. Parse only "/regex/, 'replacement'" and
        // apply with RegExp + plain string so hostile pattern values cannot run arbitrary JS.
        const format = /^\/(.+)\/, '([^']*)'$/.exec(country?.PhoneNumberPattern || '');
        if (format) {
          try {
            newVal = newVal.replace(new RegExp(format[1]), format[2]);
          } catch { /* invalid pattern — leave digits as-is */ }
        }
       }
      }

      if (this.ValidateGuestPhoneNumber) {
        this.requiredPhoneNumberLength$ = stringCount;
      } else {
        this.requiredPhoneNumberLength$ = null;
      }

    return newVal;
  }

  inputvalidation(value){
    let secureText = this.domSanitizer.sanitize(SecurityContext.HTML, value);
    if(secureText == value) {
      return false;
    }else{
      return true;
    }
  }
}
